import React from 'react';
import { Step } from 'semantic-ui-react';
import { ONBOARDING_STEPS } from '../constants';

const OnboardingSteps = ({ activeStep = 0, completedSteps = [], skippedSteps = [], unavailableSteps = [], maxReachableStep = 0, onStepClick }) => (
    <Step.Group ordered size='mini' fluid className='Onboarding__steps'>
        {ONBOARDING_STEPS.map(({ key, title, description }, index) => {
            const isUnavailable = unavailableSteps.includes(key);
            const isReachable = index <= maxReachableStep && !isUnavailable;
            return (
                <Step
                    key={key}
                    active={index === activeStep}
                    completed={completedSteps.includes(key)}
                    disabled={!isReachable}
                    link={isReachable && index !== activeStep}
                    onClick={isReachable ? () => onStepClick(key) : undefined}
                >
                    <Step.Content>
                        <Step.Title>{title}</Step.Title>
                        <Step.Description>
                            {isUnavailable
                                ? <span className='Onboarding__unavailable-label'>Not included in your plan</span>
                                : skippedSteps.includes(key) && !completedSteps.includes(key) ? <span className='Onboarding__skipped-label'>Skipped</span> : description}
                        </Step.Description>
                    </Step.Content>
                </Step>
            );
        })}
    </Step.Group>
);

export default OnboardingSteps;
